import { isProgramActive } from "../checkProgramActiveStatus";
import { AWARD_CODES } from "../../enums/award-codes";
import { PERSONA } from "../../enums/persona";
import type { EligibleIncentive } from "../../../services/MyBizShell/mybizShellAPI.types";

/**
 * Check if SSI Upline Report should be shown
 * Requirements:
 * - Config flag showSSIUpline is true
 * - Market has STRONG_START_INCENTIVE program active
 * - ABO persona > NEW (not a new ABO)
 */
export const isSSIUplineEligible = (
  eligibleIncentives: EligibleIncentive[],
  persona: PERSONA,
  featureFlag: boolean,
): boolean => {
  const marketHasSSI = isProgramActive(eligibleIncentives, AWARD_CODES.STRONG_START_INCENTIVE, featureFlag);
  return persona > PERSONA.NEW && marketHasSSI;
};

/**
 * Check if SSI program is active for routing/menu purposes (matches backend Group Management API logic)
 * Requirements:
 * - Config flag showSSIUpline is true
 * - ABO has STRONG_START_INCENTIVE (533) in eligible incentives
 * Note: No persona check - if backend returns SSI as enabled, frontend allows access
 */
export const hasSSIProgramActive = (
  eligibleIncentives: EligibleIncentive[] | undefined,
  featureFlag: boolean,
): boolean => {
  if (!featureFlag || !eligibleIncentives) return false;
  return eligibleIncentives.some((award) => award.awardNumber === AWARD_CODES.STRONG_START_INCENTIVE);
};

/**
 * Check if Bronze Group Tracking should be shown
 * Requirements:
 * - Config flag showBronzeGroupTracking is true
 * - ABO has BRONZE_GROUP_TRACKING in eligible incentives
 * - Program is active
 */
export const isBronzeGroupTrackingEligible = (
  eligibleIncentives: EligibleIncentive[],
  featureFlag: boolean,
): boolean => {
  return isProgramActive(eligibleIncentives, AWARD_CODES.BRONZE_GROUP_TRACKING, featureFlag);
};
